import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

type PriceSectionHeaderProps = {
    title: string;
    className?: string;
};

const PriceSectionHeader = (props: PriceSectionHeaderProps) => {
    const { title, className } = props;

    return (
        <section
            className={cn('flex justify-start items-center flex-grow gap-3 border-t border-b p-4 pl-8', className)}
        >
            <header className="flex flex-col justify-start items-start gap-2.5">
                <div className="flex justify-start items-center relative">
                    <h2 className="text-base text-left uppercase text-dark">{title}</h2>
                </div>
            </header>
        </section>
    );
};

export default PriceSectionHeader;
